import { gql } from '@apollo/client';

const START_HOLTER_STUDY_PROCESSING = gql`
  mutation startHolterStudyProcessing($input: HolterStudyProcessingInput!) {
    startHolterStudyProcessing(input: $input) {
      isSuccess
      message
      isReady
      processingStudyFids
      simultaneousStudyLimit
    }
  }
`;

export default START_HOLTER_STUDY_PROCESSING;
